import { defineElement, html, TemplateElement } from '@webtides/element-js';
import '../dropdown/dropdown';
import DropDownEvents from '../dropdown/DropDownEvents';

class FormTopicSelectionField extends TemplateElement {
    constructor() {
        super({ deferUpdate: true });
    }

    properties() {
        return {
            mainOptions: [],
            relation: [],
            dropdownInputName: '',
            categories: [{ default: false }],
            subCategories: [{ default: false }],
            selectedCategory: 'all',
            selectedCategoryValue: '',
            existSubCategory: false,
            selectedSubCategory: '',
            subCategoryDisabled: false,
            categoryLabelHint: '',
            categoryLabel: '',
            categorySort: false,
            subcategoryLabelHint: '',
            subcategoryLabel: '',
            subcategorySort: false,
        };
    }

    connected() {
        this.checkExistingOfSubCategory();
        this.requestUpdate();
    }

    events() {
        return {
            this: {
                [DropDownEvents.CHANGE_OPTION]: (ev) => {
                    if (ev.detail.type === 'category') {
                        this.selectedCategory = ev.detail.label;
                        this.selectedCategoryValue = ev.detail.value;
                        this.categories = this.categories.filter((item) => item.value !== '');
                        this.selectedSubCategory = 'all';
                        this.checkExistingOfSubCategory();
                        this.updateSubCategories();
                        this.requestUpdate();
                    } else if (ev.detail.type === 'subCategory') {
                        this.selectedSubCategory = ev.detail.value;
                        this.updateSubCategories();
                    }
                },
            },
        };
    }

    checkExistingOfSubCategory() {
        if (this.selectedCategoryValue === '') {
            this.subCategoryDisabled = true;
            this.selectedSubCategory = this.selectedCategoryValue;
        } else {
            this.existSubCategory = this.relation[this.selectedCategory].length > 0;

            if (this.existSubCategory) {
                this.subCategoryDisabled = false;
            } else {
                this.subCategoryDisabled = true;
                this.selectedSubCategory = this.selectedCategoryValue;
            }
        }
        this.updateSubCategories();
    }

    updateSubCategories() {
        const getSubCategories = this.relation[this.selectedCategory];

        if (getSubCategories) {
            const subCategories = getSubCategories.map((subCategory) => {
                return {
                    value: subCategory.value,
                    label: subCategory.label,
                    selected: subCategory === this.selectedSubCategory,
                };
            });
            this.subCategories = subCategories.filter((item) => item.value !== '');
            if (this.subcategorySort) {
                this.subCategories.sort((a, b) => a.label.localeCompare(b.label));
            }
        }
    }

    templateCategories() {
        const categories = this.mainOptions.map((option) => {
            return { value: option.value, label: option.label, selected: false };
        });
        this.categories = categories;
        if (this.categorySort) {
            this.categories.sort((a, b) => a.label.localeCompare(b.label));
        }
        return html`
            <dropdown-element
                options="${JSON.stringify(this.categories)}"
                default-option-override="${JSON.stringify({
                    value: '',
                    label: this.categoryLabel,
                    selected: true,
                    default: true,
                })}"
                type="category"
                required="true"></dropdown-element>
        `;
    }

    templateSubCategories() {
        return html`
            <dropdown-element
                options="${JSON.stringify(this.subCategories)}"
                default-option-override="${JSON.stringify({
                    value: '',
                    label: this.subcategoryLabel,
                    selected: true,
                    default: true,
                })}"
                type="subCategory"></dropdown-element>
        `;
    }

    template() {
        return html`
            <div class="flex flex-col gap-4 sm:flex-row sm:items-end">
                <div class="sm:w-1/2">
                    <div class="mb-3 font-book text-grey-900">${this.categoryLabelHint}</div>
                    <div class="rounded border-2 border-grey-400 text-grey-500">${this.templateCategories()}</div>
                </div>
                ${this.subCategoryDisabled
                    ? ''
                    : html`
                          <div class="sm:w-1/2">
                              <div class="mb-3 font-book text-grey-900">${this.subcategoryLabelHint}</div>
                              <div class="rounded border-2 border-grey-400 text-grey-500">
                                  ${this.templateSubCategories()}
                              </div>
                          </div>
                      `}
                <input
                    type="hidden"
                    name="${this.dropdownInputName}"
                    value="${this.selectedSubCategory === 'all'
                        ? this.selectedCategoryValue
                        : this.selectedSubCategory}" />
            </div>
        `;
    }
}

export function define() {
    defineElement('form-topic-selection-field', FormTopicSelectionField);
}
